<div class="padd3 modal-container">
  <div class="modal-header d-flex justify-content-center mt-3 mb-2">
    <h3><b><u>{{ title }}</u></b></h3>
    <a (click)="onPopupClose()" class="close mat-modal-close"><i class="material-icons">close</i></a>
  </div>
  <div class="modal-body mt-2">
    <div [innerHTML]="labelText"></div>
  </div>
  <div class="modal-footer d-flex justify-content-center mt-3 mb-2">
    <button
      class="btn btn-secondary mx-2"
      type="button"
      (click)="onCancel()"
    >
      {{ cancelButtonText }}
    </button>
  </div>
</div>
